/* Irrelevant – colourway swatch image preview on product cards */
(function(){
  if (window.__irrSwatches) return; window.__irrSwatches = true;
  function mainImg(el){
    var card = el.closest('.product-card'); if(!card) return null;
    return card.querySelector('.product-card__image-main img') || card.querySelector('.product-card__image img');
  }
  function swap(e){
    var a = e.target && e.target.closest && e.target.closest('.irr-swatches--card .irr-swatch'); if(!a || !a.dataset.irrSrc) return;
    var img = mainImg(a); if(!img) return;
    if(!img.dataset.irrOrigSrc){ var o = img.currentSrc || img.src; if (o.indexOf('data:') === 0 && img.dataset.main) o = img.dataset.main.replace('width=50','width=900'); img.dataset.irrOrigSrc = o; img.dataset.irrOrigSrcset = img.getAttribute('srcset') || ''; }
    img.setAttribute('srcset', a.dataset.irrSrcset || ''); img.src = a.dataset.irrSrc;
  }
  function restore(e){
    var a = e.target && e.target.closest && e.target.closest('.irr-swatches--card .irr-swatch'); if(!a) return;
    var img = mainImg(a); if(!img || !img.dataset.irrOrigSrc) return;
    if(img.dataset.irrOrigSrcset){ img.setAttribute('srcset', img.dataset.irrOrigSrcset); } else { img.removeAttribute('srcset'); }
    img.src = img.dataset.irrOrigSrc; if (img.src.indexOf('data:') !== 0) img.classList.add('image-loaded');
  }
  document.addEventListener('mouseover', swap); document.addEventListener('focusin', swap);
  document.addEventListener('mouseout', restore); document.addEventListener('focusout', restore);
})();
